import React, { Component } from 'react';
import SiSideNav from '../components/sidenav';
import TopHeader from '../components/header';
import Approve from '../views/Approve';



class ApprovePage extends Component {

    constructor(props) {
        super(props);
    }

    openModal = () => {
        alert("modal opened");
    }

    render() {
        return (
            <div className="root">
                <TopHeader history={this.props.history} />
                {/* <SiSideNav history={this.props.history} selected="dashboard" /> */}
                <Approve openModal={this.openModal} />
                {/* <SupportRemoteAccess/>
                <RemoteAccessform/> */}
            </div>
        )
    }
}

export default ApprovePage;